import styled from 'styled-components';

import { Container } from '@riac/design-system';
import { TextButton } from '@riac/design-system';
import { AuctionDateContainer } from '../AuctionDate/AuctionDate';

export const ActiveAuctionAside = styled.aside`
  background: ${(props) => props.theme.black[95]};
`;

export const ActiveAuctionContainer = styled(Container)`
  justify-content: space-evenly;
  padding: 40px 15px;
`;

export const ActiveAuctionInfo = styled.div`
  strong {
    font-size: 3rem;
    line-height: 1.2;
    font-family: ${(props) => props.theme.serif};
    color: ${(props) => props.theme.gold[50]};
  }
  ${AuctionDateContainer} {
    font-size: 1.6rem;
  }
  ${TextButton} {
    svg:first-child {
      color: ${(props) => props.theme.gold[50]};
    }
  }
`;

export const ActiveAuctionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 1em;
`;
